// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as DropdownField$OrcaPaymentPage from "./DropdownField.bs.js";
import * as PixPaymentInput$OrcaPaymentPage from "./PixPaymentInput.bs.js";

function DocumentNumberInput(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userDocumentType);
  var documentType = match$1[0];
  var setDocumentNumber = Recoil.useSetRecoilState(RecoilAtoms$OrcaPaymentPage.userDocumentNumber);
  var pixCNPJ = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.userPixCNPJ);
  var pixCPF = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.userPixCPF);
  React.useEffect((function () {
          switch (documentType) {
            case "cnpj" :
                setDocumentNumber(function (param) {
                      return pixCNPJ;
                    });
                break;
            case "cpf" :
                setDocumentNumber(function (param) {
                      return pixCPF;
                    });
                break;
            default:
              setDocumentNumber(function (param) {
                    return RecoilAtoms$OrcaPaymentPage.defaultFieldValues;
                  });
          }
        }), [
        documentType,
        pixCNPJ,
        pixCPF
      ]);
  var tmp;
  switch (documentType) {
    case "cnpj" :
        tmp = React.createElement(PixPaymentInput$OrcaPaymentPage.make, {
              fieldType: "pixCNPJ"
            });
        break;
    case "cpf" :
        tmp = React.createElement(PixPaymentInput$OrcaPaymentPage.make, {
              fieldType: "pixCPF"
            });
        break;
    default:
      tmp = null;
  }
  return React.createElement("div", {
              className: "flex w-full"
            }, React.createElement(DropdownField$OrcaPaymentPage.make, {
                  appearance: match.config.appearance,
                  value: documentType,
                  setValue: match$1[1],
                  fieldName: match.localeString.documentTypeLabel,
                  options: props.options,
                  width: "w-40 mr-2"
                }), tmp);
}

var make = DocumentNumberInput;

export {
  make ,
}
/* react Not a pure module */
